import {
  ContentsApiResponse,
  ContentsApiResponseResultsType,
  mapApiSearchContentResultsFromApiToVm,
} from '~/searchApi';

import { usePageBuilderStore } from '../../hooks/usePageBuilderStore';
import { AnyBlock } from '../../types';
import { DraggableContent } from './DraggableContent';
import { ReorderGrid } from './ReorderGrid/ReorderGrid';

export type MKTalentContentFields = Pick<
  ContentsApiResponseResultsType,
  | 'assets'
  | 'creator'
  | 'id'
  | 'platform'
  | 'share_link'
  | 'network_id'
  | 'content_type'
  | 'external_url'
  | 'status'
>;

export interface TalentContentProperties {
  creatorId: string;
  customContent: MKTalentContentFields[];
  showInShared: boolean;
}

interface Props extends TalentContentProperties {
  blockId: string;
}

export const TalentContent: React.FC<Props> = ({ blockId }: Props) => {
  const { blocks, updateBlock } = usePageBuilderStore();

  // Find the block first
  const block = blocks.find((b) => b.id === blockId) as AnyBlock | undefined;

  // Extract properties safely
  const items = block?.properties
    ? (block.properties as TalentContentProperties).customContent
    : [];
  const showInShared = block?.properties
    ? (block.properties as TalentContentProperties).showInShared
    : false;

  const setItems = (newItems: ContentsApiResponse['results']) => {
    updateBlock(blockId, {
      ...block,
      properties: {
        ...(block?.properties as TalentContentProperties),
        customContent: newItems,
      },
    } as AnyBlock);
  };

  // Map the content to view model format for rendering
  // @ts-ignore - MKTalentContent type does not have all fields from ContentSearchApiResponse
  const contentToRender = mapApiSearchContentResultsFromApiToVm(items);

  return (
    <>
      <ReorderGrid
        values={items}
        onReorder={setItems}
        className="flex shrink-0 snap-x snap-mandatory gap-4 overflow-x-auto tab:flex-wrap"
      >
        {contentToRender.map((content, index) => (
          <DraggableContent
            key={content.id}
            content={content}
            index={index}
            items={items}
            blockId={blockId}
            showMetrics={showInShared}
          />
        ))}
        <div className="grow-[999]">
          {/* This div is necessary to prevent last image to expand full width */}
        </div>
      </ReorderGrid>
    </>
  );
};
